/* eslint-disable react-hooks/exhaustive-deps */
import { FC } from 'react'
import { useSelector } from 'react-redux'

import { Step1Sub1 } from './Step1Sub1'

const Step1: FC = () => {
  // const [subStep, setSubStep] = useState(1);

  const loanSubStep = useSelector((state: any) => state.loan.loanSubStep)

  return <>{loanSubStep === 1 && <Step1Sub1 />}</>
}

export { Step1 }
